import type {
  TargetGroupSwitch,
  TargetGroupSwitch_TargetGroupItem,
} from "../../aysa_api/models/target_group_switch.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  createBaseSectionTracker,
  encodeSectionTracker,
  decodeSectionTracker,
} from "../../aysa_api/models/tracker";
import {
  createBaseLink,
  encodeLink,
  decodeLink,
} from "../../aysa_api/models/link";
import {
  encodeTargetGroup,
  decodeTargetGroup,
} from "../../aysa_api/models/target_group";

export const createBaseTargetGroupSwitch = (): TargetGroupSwitch => {
  return {
    targetGroups: [],
    tracker: createBaseSectionTracker(),
  };
};

export const decodeTargetGroupSwitch = (
  reader: Reader,
  length: number
): TargetGroupSwitch => {
  const end = reader.pos + length;
  const message = createBaseTargetGroupSwitch();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.targetGroups.push(
          decodeTargetGroupSwitch_TargetGroupItem(reader, reader.uint32())
        );

        break;
      case 2:
        message.tracker = decodeSectionTracker(reader, reader.uint32());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeTargetGroupSwitch = (
  writer: Writer,
  message: TargetGroupSwitch
): Writer => {
  for (const value of message.targetGroups) {
    encodeTargetGroupSwitch_TargetGroupItem(
      writer.uint32(10).fork(),
      value
    ).ldelim();
  }
  encodeSectionTracker(writer.uint32(18).fork(), message.tracker).ldelim();

  return writer;
};

export const createBaseTargetGroupSwitch_TargetGroupItem =
  (): TargetGroupSwitch_TargetGroupItem => {
    return {
      targetGroup: 0,
      link: createBaseLink(),
    };
  };

export const decodeTargetGroupSwitch_TargetGroupItem = (
  reader: Reader,
  length: number
): TargetGroupSwitch_TargetGroupItem => {
  const end = reader.pos + length;
  const message = createBaseTargetGroupSwitch_TargetGroupItem();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.targetGroup = decodeTargetGroup(reader);

        break;
      case 2:
        message.link = decodeLink(reader, reader.uint32());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeTargetGroupSwitch_TargetGroupItem = (
  writer: Writer,
  message: TargetGroupSwitch_TargetGroupItem
): Writer => {
  encodeTargetGroup(writer.uint32(8), message.targetGroup);
  encodeLink(writer.uint32(18).fork(), message.link).ldelim();

  return writer;
};
